import ErrorMessage from 'components/common/ErrorMessage';
import { Controller, useFormContext } from 'react-hook-form';

import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { Option } from 'types/global';
export const FormEntry = ({
  field,
  validate,
  required,
  placeholder,
  ...rest
}: {
  field: {
    name: string;
    type: string;
    options?: Option[];
    label: string;
    editable: boolean;
    isMulti?: boolean;
  };
  [x: string]: any;
}) => {
  const {
    formState: { errors },
    control,
    register
  } = useFormContext();

  return (
    <Box {...rest} sx={{ mb: 1 }}>
      {field.type === 'select' && control ? (
        <>
          {field.isMulti ? (
            <Controller
              control={control}
              name={field.name as any}
              rules={{ required: required ? required : false }}
              render={({ field: controllerField }) => (
                <FormControl>
                  <InputLabel>{field.label}</InputLabel>
                  <Select
                    label={field.label}
                    value={
                      controllerField.value
                        ? controllerField.value.map(
                            (item: Option) => item.value
                          )
                        : []
                    }
                    onChange={e =>
                      controllerField.onChange(
                        e.target.value.map((value: string) =>
                          field.options?.find(option => option.value === value)
                        )
                      )
                    }
                    multiple
                    inputProps={{ id: field.name }}
                  >
                    {field.options?.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          ) : (
            <Controller
              control={control}
              name={field.name as any}
              rules={{ required: required ? required : false }}
              render={({ field: controllerField }) => (
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel>{field.label}</InputLabel>
                  <Select
                    label={field.label}
                    value={
                      controllerField.value && controllerField.value.value
                        ? controllerField.value.value
                        : ''
                    }
                    onChange={e =>
                      controllerField.onChange(
                        field.options?.find(
                          option => option.value === e.target.value
                        )
                      )
                    }
                    inputProps={{ id: field.name }}
                  >
                    {field.options?.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          )}

          {errors?.[field.name]?.type === 'required' && (
            <ErrorMessage type="required" />
          )}
        </>
      ) : field.type === 'textarea' ? (
        <>
          <TextField
            multiline
            rows={3}
            label={field.label}
            placeholder="Ex. Formulation Chemist"
            {...register(field.name, { required: !!required })}
            fullWidth
            error={!!errors?.[field.name]}
          />
          {errors?.[field.name]?.type === 'required' && (
            <ErrorMessage type="required" />
          )}
        </>
      ) : field.type === 'autocomplete' ? (
        <Controller
          control={control}
          name={field.name as any}
          rules={{ required: !!required }}
          render={({ field: controllerField }) => (
            <Autocomplete
              multiple
              disableCloseOnSelect={true}
              options={field.options || []}
              getOptionLabel={option => option.label}
              value={
                controllerField.value.filter((item: string) => item !== '') ||
                undefined
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              onChange={(event, value) => controllerField.onChange(value)}
              renderInput={params => (
                <TextField
                  {...params}
                  label={field.label}
                  placeholder={placeholder || ''}
                  error={!!errors?.[field.name]}
                />
              )}
            />
          )}
        />
      ) : (
        <>
          <TextField
            label={field.label}
            type={field.type}
            disabled={!field.editable}
            placeholder={placeholder || ''}
            sx={{ mb: 1 }}
            fullWidth
            {...register(field.name, {
              required: !!required,
              pattern: validate ? /\d+/g : undefined
            })}
            error={!!errors?.[field.name]}
          />
          {errors?.[field.name]?.type === 'pattern' && (
            <ErrorMessage type="onlyNumbers" />
          )}
          {errors?.[field.name]?.type === 'required' && (
            <ErrorMessage type="required" />
          )}
        </>
      )}
    </Box>
  );
};
